import { useCallback, useEffect, useRef, useState } from 'react'
import { useBackGesture } from '@/shared/hooks/use-back-gesture'
import { ANIMATION_DURATION_MS, NEXT_TICK_MS } from '@/shared/constants/timings'

// Step navigation + id card flip shared by the create and edit claim forms
export function useClaimFormSteps(stepCount: number) {
  const [currentStep, setCurrentStep] = useState(0)
  const [isFlipping, setIsFlipping] = useState(false)
  const pendingStepRef = useRef<number | undefined>(undefined)

  const flipToStep = useCallback((nextStep: number) => {
    pendingStepRef.current = nextStep
    setIsFlipping(true)
    setTimeout(() => {
      document.querySelector('main')?.scrollTo({ top: 0, behavior: 'smooth' })
    }, NEXT_TICK_MS)
  }, [])

  useEffect(() => {
    if (!isFlipping) return
    const timer = setTimeout(() => {
      if (pendingStepRef.current !== undefined) {
        setCurrentStep(pendingStepRef.current)
        pendingStepRef.current = undefined
      }
      setIsFlipping(false)
    }, ANIMATION_DURATION_MS)
    return () => clearTimeout(timer)
  }, [isFlipping])

  const handleBack = useCallback(() => {
    if (currentStep > 0) flipToStep(currentStep - 1)
  }, [currentStep, flipToStep])

  useBackGesture(handleBack, currentStep > 0)

  return {
    currentStep,
    isFlipping,
    isLastStep: currentStep === stepCount - 1,
    flipToStep,
    handleBack,
  }
}
